import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class BoatKind extends Cloneable {
    static ANY = new BoatKind(0, "ANY");
    static VICKY = new BoatKind(1, "VICKY");
    static RINDA = new BoatKind(2, "RINDA");
    static THOMAS = new BoatKind(3, "THOMAS");
    static CHAMPION = new BoatKind(4, "CHAMPION");

    static _values = [
        this.ANY,
        this.VICKY,
        this.RINDA,
        this.THOMAS,
        this.CHAMPION
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, BoatKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof BoatKind) {
            return BoatKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof BoatKind) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new BoatKind());
        } else if (target instanceof BoatKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(BoatKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});